import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
//import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import ReCaptcha from "@NA/Overrides/Components/ReCaptcha";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import Button, { ButtonProps } from "@insite/mobius/Button";
import Link from "@insite/mobius/Link";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import { Checkbox, Select } from "@insite/mobius/index";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { FC, useState, useContext } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";
import { getCountriesDataView } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries, {
    loadCurrentCountriesParameter,
} from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import { CustomSettingCollectionModel } from "@NA/Store/CustomTypeModel/CustomSettingCollectionModel";
import adiAddAccount from "@NA/Handlers/ADIAddAcountHandler";
import getColor from "@insite/mobius/utilities/getColor";
import Plus from "@insite/mobius/Icons/Plus";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { addADIAccount, GetAddAccountParamater } from "@NA/Services/ADIAddAccountService";
import ADIColors from "@NA/Utils/ADIColors";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { SelectProps } from "@insite/mobius/Select";
import resetReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ResetReCaptcha";
import ReCAPTCHA from "react-google-recaptcha";

const mapStateToProps = (state: ApplicationState) => {
    const countriesDataView = getCountriesDataView(state, loadCurrentCountriesParameter);
    return {
        isAuthenticated: state.context.session!.isAuthenticated,
        settingsCollection: getSettingsCollection(state) as unknown as CustomSettingCollectionModel,
        shouldLoadCountries: !countriesDataView.value && !countriesDataView.isLoading,
        countriesDataView,
    };
};

const mapDispatchToProps = {
    loadCurrentCountries,
    adiAddAccount,
    //validateReCaptcha: makeHandlerChainAwaitable<{}, boolean>(validateReCaptcha),
    validateReCaptcha: makeHandlerChainAwaitable<
        { location: string; recaptchaRef: React.RefObject<ReCAPTCHA> },
        boolean
    >(validateReCaptcha),
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface ADICustomerRegistrationStyles {
    accordianContainer?: InjectableCss;
    accordianSection?: AccordionSectionPresentationProps;
    contentWrapper?: InjectableCss;
    fieldWrapper?: InjectableCss;
    captchaFieldWrapper?: InjectableCss;
    nextButtonWrapper?: InjectableCss;
    checkboxGroupWrapper?: InjectableCss;
    textFieldStyles?: TextFieldProps;
    checkboxWrapper?: InjectableCss;
    checkboxWrapperError?: InjectableCss;
    buttonContainer?: InjectableCss;
    snapCustomer?: InjectableCss;
    errorMsg?: InjectableCss;
    requiredStyles?: InjectableCss;
    selectStateStyes?: SelectProps;
    selectStateStylesDisabled?: SelectProps;
    bacCountrySectionHide?: InjectableCss;
}

export const ADICustomerRegistrationStyles: ADICustomerRegistrationStyles = {
    requiredStyles: {
        css: css`
        position: absolute;
        left: 48px;
        bottom: 22px;
        font-size: 14px;
        text-transform: capitalize;
        font-weight: normal;
        line-height: 1.57;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`left: 13px;
                        bottom: 29px;`,
                        css`left: 13px;
                        bottom: 29px;`,
                        css`left: 24px`,
                        null,
                        null,
                    ]
                )}

        `
    },
    checkboxWrapper: {
        css: css`
            display: flex;
            align-items: flex-start;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            [class^="CheckboxStyle-"] {
                margin-top: 4px;
            }
        `,
    },
    checkboxWrapperError: {
        css: css`
            display: flex;
            align-items: flex-start;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            [class^="CheckboxStyle-"] {
                margin-top: 4px;
                border: 1px solid rgb(172, 30, 45) !important;
            }
        `,
    },
    snapCustomer: {
        css: css`
        margin-left: 10px;
        margin-top: 4px;
        `,
    },
    accordianContainer: {
        css: css`
            margin-bottom: 20px;

            label {
                font-weight: bold;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
            }

            [data-test-selector="undefined-error"] {
                display: block;
                position: relative;
                padding-left: 18px;
                color: ${getColor("text.main")};
                font-weight: normal;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                :before {
                    position: absolute;
                    background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/BecomeACustomerBanner/np-error@2x.png)
                        no-repeat;
                    content: "";
                    width: 12px;
                    background-size: contain;
                    height: 12px;
                    left: 0;
                    top: 4px;
                }
            }
        `,
    },
    accordianSection: {
        toggleIconProps: {
            src: Plus,
            size: 24,
            css: css`
                margin-right: 20px;
            `,
        },
        headerProps: {
            css: css`
                background-color: ${getColor("common.accent")};
                border-radius: 4px;
                padding: 12px 0;
                position: relative;
                > button {
                    border: 0;
                    padding-top: 14px;
                    padding-bottom: 14px;
                    :focus {
                        border: 0 !important;
                        outline: 0 !important;
                        padding-top: 14px;
                        padding-bottom: 14px;
                        padding-left: 15px;
                    }
                    span {
                        font-size: ${getProp("theme.typography.h3.size")};
                        font-weight: 700;
                        margin-left: 40px;
                        ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                        font-size: ${getProp("theme.typography.headerSecondary.size")};
                                        font-weight: 700;
                                        margin-left: 0px;
                                    `,
                            css`
                                        font-size: ${getProp("theme.typography.headerSecondary.size")};
                                        font-weight: 700;
                                        margin-left: 0px;
                                    `,

                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
                        color: ${ADIColors.darkBlue1}
                    }
                }
                button[aria-expanded="true"] {
                    span[class^="IconWrapper-"] {
                        visibility: hidden;
                        pointer-events: none;
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                padding-top: 14px;
                background-color: ${getColor("common.accent")};
                border: 0;
                padding-bottom: 20px;
                position: relative;
            `,
        },
    },
    contentWrapper: {
        css: css`
            width: 100%;
            margin: 0 auto;
            max-width: 480px;
        `,
    },
    fieldWrapper: {
        css: css`
            margin-bottom: 12px;
            [class^="FormInputWrapper-"] {
                margin-top: 3px !important;
                input[aria-invalid="true"] {
                    border: 1px solid rgb(172, 30, 45) !important;
                }
                select[aria-invalid="true"] {
                    border: 1px solid rgb(172, 30, 45) !important;
                }
                [class^="DescriptionWrapper-"] {
                    margin-top: 3px !important;
                }
            }

            textarea {
                display: block;
                min-height: 90px;
                resize: none;
                width: 100%;
                overflow: auto;
                background: ${getColor("secondary.contrast")};
                border: 1px solid ${getColor("common.border")};
                border-radius: 7px;
                padding: 0 10px 0 10px;
            }
        `,
    },
    captchaFieldWrapper: {
        css: css`
        margin-bottom: 12px;
        ${({ theme }) => { return breakpointMediaQueries(
            theme, [css`         
            transform: scale(0.94);
            transform-origin: 0px 0px;
            `,],"max",); 
        }}
        `,
    },
    textFieldStyles: {
        css: css`
        &.disabledField{
            background: rgb(245, 245, 245) !important;
            color: #CCCCCC !important;
            cursor: not-allowed;
            pointer-events: none;
        }
        `
        , labelProps: {
            size: 14,
            weight: "bold",
            css: css`
                text-transform: none !important;
            `
        },
    },
    nextButtonWrapper: {
        css: css`
            margin-top: 40px;
            text-align: right;
            button {
                border-radius: 4px;
                font-size: ${getProp("theme.typography.h6.size")};
                padding: 15px 40px;
            }
        `,
    },
    checkboxGroupWrapper: {
        css: css`
            margin-top: 15px;
            column-count: 2;
            column-gap: 10px;
            display: grid;
            grid-template-columns: 66% 66%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`display: flex; flex-direction: column;`,
                        null,
                        null,
                    ], "max",
                )}
            > div {
                margin-bottom: 15px;
                [class^="TypographyStyle-"] {
                    margin-left: 15px;
                }
            }
        `,
    },
    buttonContainer: {
        css: css`
            display: flex;
            justify-content: end;
            bottom: 0px;
            padding: 0px 10px;
            left: 0px;
        `,
    },
    errorMsg: {
        css: css`
            color: ${ADIColors.errorMsgRed};
            margin-bottom: 15px;
            display: block;
        `
    },
    selectStateStyes: {
        css: css`
            background: rgb(245, 245, 245) !important;
            color: #CCCCCC !important;
            cursor: not-allowed;
            pointer-events: none;
        `
    },
    selectStateStylesDisabled: {
        css: css``
    },
    bacCountrySectionHide: {
        css: css`
            display: none;
        `
    }
};

const styles = ADICustomerRegistrationStyles;
const emailRegexp = new RegExp(/^[A-Za-z0-9]+([._+-][a-zA-A0-9]+)*@[a-zA-A0-9-]+\.[a-zA-A]{2,}$/);
const StyledForm = getStyledWrapper("form");
type ProductLineValue =
    | "Access Control & Communications"
    | "Pro AV"
    | "Power"
    | "Residential AV"
    | "Central Vacuum"
    | "Structured Wiring"
    | "Enterprise Connectivity"
    | "Tools & Hardware"
    | "Fire"
    | "Video Surveillance"
    | "Intrusion & Smart Home"
    | "Wire & Cable"
    | "Networking"
    | "Solar";

export const ADICustomerRegistration: FC<Props> = ({
    isAuthenticated,
    settingsCollection,
    shouldLoadCountries,
    countriesDataView,
    loadCurrentCountries,
    adiAddAccount,
    validateReCaptcha,
    history,
}) => {



    const bacSettingSettings = settingsCollection.bacSettingSettings;
    const recaptchaRef: React.RefObject<ReCAPTCHA> = React.createRef();
    //error Messages
    const companyNameErrorMessage = translate("Company is a required field.");
    const firstNameErrorMessage = translate("First Name is a required field.");
    const lastNameErrorMessage = translate("Last Name is a required field.");
    const titleErrorMessage = translate("Title is a required field.");
    const taxIDErrorMessage = translate("Tax ID or License # is a required field.");
    const businessPhoneErrorMessage = translate("Business phone number is a required field.");
    const businessPhoneLengthErrorMessage = translate("Business phone number must contain at least 10 digits");
    const emailRequiredFieldMessage = translate("Email Address is a required field");
    const emailFieldMessage = translate("Please enter a valid email address.");
    const emailMisMatchErrorMessage = translate("The email address does not match. Please re-enter it.");
    const billingAddressErrorMessage = translate("Billing address is a required field.");
    const billingCityErrorMessage = translate("Billing city is a required field.");
    const billingStateErrorMessage = translate("Billing State is a required field.");
    const billingPostalCodeErrorMessage = translate("Billing postal code is a required field.");
    const shippingAddressErrorMessage = translate("Shipping address is a required field.");
    const shippingCityErrorMessage = translate("Shipping city is a required field.");
    const shippingStateErrorMessage = translate("Shipping State is a required field.");
    const shippingPostalCodeErrorMessage = translate("Shipping postal code is a required field.");
    const selectOptionErrorMsg = translate("Select an Option");
    const extErrorMessage = translate("Please enter number only");
    const mobilePhoneLengthErrorMessage = translate("Mobile phone number must contain at least 10 digits");
    const validBillingPostalCodeErrorMessage = translate("Enter Valid Billing Zip Code");
    const validShippingPostalCodeErrorMessage = translate("Enter Valid Shipping Zip Code");

    // states to open Accordian
    const containerRef = React.useRef<HTMLDivElement | null>(null);
    const contactRef = React.useRef<HTMLDivElement | null>(null);
    const [openContact, setOpenContact] = useState(true);
    const billingRef = React.useRef<HTMLDivElement | null>(null);
    const [openBilling, setOpenBilling] = useState(false);
    const shippingRef = React.useRef<HTMLDivElement | null>(null);
    const [openShipping, setOpenShipping] = useState(false);
    const companyRef = React.useRef<HTMLDivElement | null>(null);
    const [opencompany, setOpenCompany] = useState(false);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const [country, setCountry] = useState(countriesDataView.value?.find(item => item.name === "United States"));
    const [shippingSameAsBilling, setShippingSameAsBilling] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [companyName, setCompanyName] = useState("");
    const [companyError, setCompanyError] = useState(companyNameErrorMessage);

    const [firstName, setFirstName] = useState("");
    const [firstNameError, setFirstNameError] = useState(firstNameErrorMessage);

    const [lastName, setLastName] = useState("");
    const [lastNameError, setLastNameError] = useState(lastNameErrorMessage);

    const [title, setTitle] = useState("");
    const [titleError, setTitleError] = useState(titleErrorMessage);

    const [taxID, setTaxID] = useState("");
    const [taxIDError, setTaxIDError] = useState(taxIDErrorMessage);

    const [businessPhone, setBusinessPhone] = useState("");
    const [businessPhoneError, setBusinessPhoneError] = useState(businessPhoneErrorMessage);

    const [mobilePhone, setMobilePhone] = useState("");
    const [mobilePhoneError, setMobilePhoneError] = useState("");

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);

    const [confirmEmail, setconfirmEmail] = useState("");
    const [confirmEmailError, setconfirmEmailError] = useState(emailRequiredFieldMessage);

    const [billingAddress, setBillingAddress] = useState("");
    const [billingAddressError, setBillingAddressError] = useState(billingAddressErrorMessage);

    const [billingAddress2, setBillingAddress2] = useState("");

    const [billingCity, setBillingCity] = useState("");
    const [billingCityError, setBillingCityError] = useState(billingCityErrorMessage);

    const [billingState, setBillingState] = useState("");
    const [billingStateError, setBillingStateError] = useState(billingStateErrorMessage);

    const [billingPostalCode, setBillingPostalCode] = useState("");
    const [billingPostalCodeError, setBillingPostalCodeError] = useState(billingPostalCodeErrorMessage);

    const [shippingCity, setShippingCity] = useState("");
    const [shippingCityError, setShippingCityError] = useState(shippingCityErrorMessage);

    const [shippingState, setShippingState] = useState("");
    const [shippingStateError, setShippingStateError] = useState(shippingStateErrorMessage);

    const [shippingPostalCode, setShippingPostalCode] = useState("");
    const [shippingPostalCodeError, setShippingPostalCodeError] = useState(shippingPostalCodeErrorMessage);

    const [shippingAddressError, setShippingAddressError] = useState(shippingAddressErrorMessage);
    const [shippingAddress, setShippingAddress] = useState("");

    const [shippingAddress2, setShippingAddress2] = useState("");

    const [yearsInBusiness, setYearsInBusiness] = useState("");
    const [yearsInBusinessError, setyearsInBusinessError] = useState(selectOptionErrorMsg);

    const [employeeCompany, setEmployeeCompany] = useState("");
    const [employeeCompanyError, setEmployeeCompanyError] = useState(selectOptionErrorMsg);

    const [companyLocations, setCompanyLocations] = useState("");
    const [companyLocationsError, setCompanyLocationsError] = useState(selectOptionErrorMsg);

    const [lisenceInstallerCheck, setlisenceInstallerCheck] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);

    const [companyWebiste, setCompanyWebiste] = useState("");

    const [extName, setExtName] = useState("");
    const [extError, setExtError] = useState("");

    const [productLines, setProductLines] = useState<ProductLineValue[]>([]);

    const [comments, setComments] = useState("");

    const [errorMsg, setErrorMsg] = useState<any>(null);
    const [isChecked, setIsChecked] = React.useState(false);
    const [inputValue, setInputValue] = React.useState("");

    const [captchaSelectError, setCaptchaSelectError] = useState(false);
    const [captchaErrorMsg, setCaptchaErrorMsg] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
        setInputValue("");
    
      };
      const handleInputChange = (e:any) => {
        const value = e.target.value;
        
        const regex = /^[a-zA-Z0-9]*$/;
    
        if (value.length <= 20 && regex.test(value)) {
          setInputValue(value);
        }
        
        
      };

    const handleProductLineChange = (value: ProductLineValue) => {
        const updatedCheckboxes = [...productLines];

        if (updatedCheckboxes.includes(value)) {
            updatedCheckboxes.splice(updatedCheckboxes.indexOf(value), 1);
        } else {
            updatedCheckboxes.push(value);
        }

        setProductLines(updatedCheckboxes);
    };

    React.useEffect(() => {
        if (billingRef.current && openBilling && !openContact) {
            scrollToTargetHandler(billingRef);
        }
    }, [openBilling, openContact]);
    React.useEffect(() => {
        if (shouldLoadCountries) {
            loadCurrentCountries();
        }
        const onWindowResize = () => {
            if (window.innerWidth <= 1080) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };
        onWindowResize();

        if (typeof window !== "undefined") {
            window.addEventListener("resize", onWindowResize);
        }

        return () => {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", onWindowResize);
            }
        };
    }, []);



    React.useEffect(() => {
        if (countriesDataView.value) {
            setCountry(countriesDataView.value?.find(item =>item.abbreviation==="US" ? item.name === "United States":item.name === "Puerto Rico"));
        }
    }, [countriesDataView]);

    React.useEffect(() => {
        if (shippingSameAsBilling) {
            setOpenBilling(false);
            setOpenShipping(true);
            setShippingAddress(billingAddress);
            setShippingAddress2(billingAddress2);
            setShippingAddressError("");
            setShippingCity(billingCity);
            setShippingCityError("");
            setShippingState(billingState);
            setShippingStateError("");
            setShippingPostalCode(billingPostalCode);
            setShippingPostalCodeError("");
        } else {
            setShippingAddress("");
            setShippingAddressError(shippingAddressErrorMessage);
            setShippingAddress2("");
            setShippingCity("");
            setShippingCityError(shippingCityErrorMessage);
            setShippingState("");
            setShippingStateError(shippingStateErrorMessage);
            setShippingPostalCode("");
            setShippingPostalCodeError(shippingPostalCodeErrorMessage);
        }
    }, [shippingSameAsBilling]);

    React.useEffect(() => {
        if (companyRef.current && opencompany && !openShipping) {
            scrollToTargetHandler(companyRef);
        }
    }, [opencompany, openShipping]);

    React.useEffect(() => {
        if (shippingRef.current && openShipping && !openBilling) {
            scrollToTargetHandler(shippingRef);
        }
    }, [openShipping, openBilling]);

    if (isAuthenticated) {
        if (typeof window !== "undefined") {
            history.push("/");
        }
        return null;
    }


    const scrollToTargetHandler = (targetRef: React.RefObject<HTMLDivElement>) => {
        if (targetRef.current && typeof window !== undefined) {
            window.scrollTo({ top: targetRef?.current.offsetTop - 200, behavior: "smooth" });
        }
    };



    function isValidUSZip(zipCode: string) {
        var pattern = new RegExp(bacSettingSettings.baC_PostalCode_RegeEx);
        return pattern.test(zipCode);
    }

    const contactNextHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        setOpenContact(false);
        setOpenBilling(true);
    };



    const billingNextHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        setOpenBilling(false);
        setOpenShipping(true);
    };



    const shippingNextHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        setOpenShipping(false);
        setOpenCompany(true);
    };



    const validateCompanyName = (name: string) => {
        const errorMessage = !name ? companyNameErrorMessage : "";
        setCompanyError(errorMessage);
        return !errorMessage;
    };

    const companyNameHandler = (name: string) => {
        validateCompanyName(name);
        setCompanyName(name);
    };

    const validateFirstName = (name: string) => {
        const errorMessage = !name ? firstNameErrorMessage : "";
        setFirstNameError(errorMessage);
        return !errorMessage;
    };

    const firstNameHandler = (name: string) => {
        validateFirstName(name);
        setFirstName(name);
    };

    const validateLastName = (name: string) => {
        const errorMessage = !name ? lastNameErrorMessage : "";
        setLastNameError(errorMessage);
        return !errorMessage;
    };

    const lastNameHandler = (name: string) => {
        validateLastName(name);
        setLastName(name);
    };

    const validateTitle = (name: string) => {
        const errorMessage = !name ? titleErrorMessage : "";
        setTitleError(errorMessage);
        return !errorMessage;
    };

    const titleHandler = (name: string) => {
        validateTitle(name);
        setTitle(name);
    };

    const validateExtHandler = (name: string) => {
        const errorMessage = name && !Number(name) ? extErrorMessage : "";
        setExtError(errorMessage);
        return !errorMessage;
    };

    const extHandler = (name: string) => {
        validateExtHandler(name);
        setExtName(name);
    };

    const validateTaxId = (name: string) => {
        const errorMessage = !name ? taxIDErrorMessage : "";
        setTaxIDError(errorMessage);
        return !errorMessage;
    };

    const taxIDHandler = (name: string) => {
        validateTaxId(name);
        setTaxID(name);
    };

    const validatebusinessPhone = (name: string) => {
        const errorMessage = !name
            ? businessPhoneErrorMessage
            : !Number(name) || name.length !== 10
                ? businessPhoneLengthErrorMessage
                : "";
        setBusinessPhoneError(errorMessage);
        return !errorMessage;
    };

    const businessPhoneHandler = (name: string) => {
        validatebusinessPhone(name);
        setBusinessPhone(name);
    };

    const validateMobilePhoneHandler = (name: string) => {
        const errorMessage = name && (!Number(name) || name.length !== 10) ? mobilePhoneLengthErrorMessage : "";
        setMobilePhoneError(errorMessage);
        return !errorMessage;
    };

    const mobilePhoneHandler = (name: string) => {
        validateMobilePhoneHandler(name);
        setMobilePhone(name);
    };

    const emailChangeHandler = (email: string) => {
        validateEmail(email);
        setEmail(email);
    };

    const confirmEmailChangeHandler = (email: string) => {
        validateConfirmEmail(email);
        setconfirmEmail(email);
    };

    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const validateConfirmEmail = (emailConfirm: string) => {
        const errorMessage = !emailConfirm
            ? emailRequiredFieldMessage
            : !emailRegexp.test(emailConfirm)
                ? emailFieldMessage
                : email !== emailConfirm
                    ? emailMisMatchErrorMessage
                    : "";
        setconfirmEmailError(errorMessage);
        return !errorMessage;
    };

    const validateShippingAddressHandler = (name: string) => {
        const errorMessage = !name ? shippingAddressErrorMessage : "";
        setShippingAddressError(errorMessage);
        return !errorMessage;
    };

    const shippingAddressHandler = (name: string) => {
        validateShippingAddressHandler(name);
        setShippingAddress(name);
    };

    const validateBillingAddressHandler = (name: string) => {
        const errorMessage = !name ? billingAddressErrorMessage : "";
        setBillingAddressError(errorMessage);
        return !errorMessage;
    };

    const billingAddressHandler = (name: string) => {
        validateBillingAddressHandler(name);
        setBillingAddress(name);
        if (shippingSameAsBilling) {
            setShippingAddress(name);
        }
    };

    const validateBillingCityHandler = (name: string) => {
        const errorMessage = !name ? billingCityErrorMessage : "";
        setBillingCityError(errorMessage);
        return !errorMessage;
    };

    const billingCityHandler = (name: string) => {
        validateBillingCityHandler(name);
        setBillingCity(name);
        if (shippingSameAsBilling) {
            setShippingCity(name);
        }
    };

    const validateBillingStateHandler = (name: string) => {
        const errorMessage = !name ? billingStateErrorMessage : "";
        setBillingStateError(errorMessage);
        return !errorMessage;
    };

    const billingStateHandler = (name: string) => {
        validateBillingStateHandler(name);
        setBillingState(name);
        if (shippingSameAsBilling) {
            setShippingState(name);
        }
    };

    const validateBillingPostalCodeHandler = (name: string) => {
        const errorMessage = !name
            ? billingPostalCodeErrorMessage
            : !isValidUSZip(name)
                ? validBillingPostalCodeErrorMessage
                : "";
        setBillingPostalCodeError(errorMessage);
        return !errorMessage;
    };

    const billingPostalCodeHandler = (name: string) => {
        validateBillingPostalCodeHandler(name);
        setBillingPostalCode(name);
        if (shippingSameAsBilling) {
            setShippingPostalCode(name);
        }
    };

    const handleBillingAddress2 = (name: string) => {
        setBillingAddress2(name);
        if (shippingSameAsBilling) {
            setShippingAddress2(name);
        }
    };

    const validateShippingCityHandler = (name: string) => {
        const errorMessage = !name ? shippingCityErrorMessage : "";
        setShippingCityError(errorMessage);
        return !errorMessage;
    };

    const shippingCityHandler = (name: string) => {
        validateShippingCityHandler(name);
        setShippingCity(name);
    };

    const validateShippingStateHandler = (name: string) => {
        const errorMessage = !name ? shippingStateErrorMessage : "";
        setShippingStateError(errorMessage);
        return !errorMessage;
    };

    const shippingStateHandler = (name: string) => {
        validateShippingStateHandler(name);
        setShippingState(name);
    };

    const validateShippingPostalCodeHandler = (name: string) => {
        const errorMessage = !name
            ? shippingPostalCodeErrorMessage
            : !isValidUSZip(name)
                ? validShippingPostalCodeErrorMessage
                : "";
        setShippingPostalCodeError(errorMessage);
        return !errorMessage;
    };

    const shippingPostalCodeHandler = (name: string) => {
        validateShippingPostalCodeHandler(name);
        setShippingPostalCode(name);
    };

    const validateyearsInBusinessHandler = (name: string) => {
        const errorMessage = !name ? selectOptionErrorMsg : "";
        setyearsInBusinessError(errorMessage);
        return !errorMessage;
    };

    const yearsInBusinessHandler = (name: string) => {
        validateyearsInBusinessHandler(name);
        setYearsInBusiness(name);
    };

    const validatecompanyEmployeeHandler = (name: string) => {
        const errorMessage = !name ? selectOptionErrorMsg : "";
        setEmployeeCompanyError(errorMessage);
        return !errorMessage;
    };

    const companyEmployeeHandler = (name: string) => {
        validatecompanyEmployeeHandler(name);
        setEmployeeCompany(name);
    };

    const validatecompanyLocationsHandler = (name: string) => {
        const errorMessage = !name ? selectOptionErrorMsg : "";
        setCompanyLocationsError(errorMessage);
        return !errorMessage;
    };

    const companyLocationsHandler = (name: string) => {
        validatecompanyLocationsHandler(name);
        setCompanyLocations(name);
    };

    const validateSubmitEnabled = () => {
        return !(
            companyError ||
            firstNameError ||
            lastNameError ||
            businessPhoneError ||
            emailError ||
            confirmEmailError ||
            titleError ||
            taxIDError ||
            extError ||
            mobilePhoneError ||
            billingAddressError ||
            billingCityError ||
            billingStateError ||
            billingPostalCodeError ||
            shippingAddressError ||
            shippingCityError ||
            shippingStateError ||
            shippingPostalCodeError ||
            employeeCompanyError ||
            companyLocationsError ||
            yearsInBusinessError ||
            !agreeTerms ||
            !lisenceInstallerCheck ||
            !productLines.length ||
            !captchaSelectError
        );
    };

    function scrollToElement() {
        setOpenContact(true);
        setOpenBilling(true);
        setOpenShipping(true);
        setOpenCompany(true);
        if (typeof window !== undefined) {
            const element = document.querySelector('[data-test-selector="undefined-error"]');
            if (element === null) {
                setTimeout(scrollToElement, 100);
            } else {
                const elementRect = element.getBoundingClientRect();
                window.scrollTo({
                    top: elementRect.top + window.scrollY - 200,
                    behavior: "smooth",
                });
            }
        }
    }

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        setErrorMsg("");
        event.preventDefault();
        const form = event.target as HTMLFormElement;

        if (!isSubmitted) {
            setIsSubmitted(true);
           
        }

        if (!validateSubmitEnabled()) {
            scrollToElement();
            return;
        }

        const isReCaptchaValid = await validateReCaptcha({
            location: "CreateAccount",
            recaptchaRef,
        });

        if (!isReCaptchaValid) {
            return;
        }

        const grecaptcha = (window as { [key: string]: any })["grecaptcha"];
        if (grecaptcha === undefined) {
            return;
        }

        const captchaResponseValue = grecaptcha.getResponse();
        if (captchaResponseValue === "") {
            return;
        }

        setIsSubmitting(true);
        const response = await addADIAccount({
            email: email,
            firstName: firstName,
            lastName: lastName,
            properties: {
                isBecomeACustomerPage: "true",
                phone: businessPhone,
                captchaResponse: captchaResponseValue,
            },
        } as GetAddAccountParamater);

        if (response.successful) {
            if (response.result.properties.isUserExists.toLowerCase() !== "true") {
                // Calling salesforce API
                form.submit();
            } else {
                // handle error for user exists
                setErrorMsg("Your email or phone number already exists, please contact us if you do not remember your login information.")
                // to reset capctcha in case of any error
                //resetReCaptcha()
                grecaptcha.reset();
                scrollToTargetHandler(containerRef);
            }
        } else {
            // handle API error
            setErrorMsg((response as any)?.errorMessage);
            scrollToTargetHandler(containerRef);
        }

    };

    const userCaptchaValid = (errorData: any) => {
        setCaptchaErrorMsg(errorData);
        setCaptchaSelectError(true);
    };

    

    const linkclick = () => {
        window.open("/TermsAndConditionsPage","_blank")
    };
    

    return (
        <StyledWrapper ref={containerRef}>

            {errorMsg &&
                <Typography {...styles.errorMsg}>
                    {translate(errorMsg)}
                </Typography>
            }
            <StyledForm
                onSubmit={submitHandler}
                action={bacSettingSettings.naRedesign_BecomeACustomer_SF_URL}
                method="POST"
                noValidate
            >
                <input hidden name="oid" value={bacSettingSettings.naRedesign_BecomeACustomer_SF_Oid} />
                <input
                    hidden
                    name="recordType"
                    id="recordType"
                    value={bacSettingSettings.naRedesign_BecomeACustomer_SF_RecordType}
                />
                <input hidden name="lead_source" value={bacSettingSettings.naRedesign_BecomeACustomer_SF_LeadSource} />
                <input hidden name="retURL" value={bacSettingSettings.nA_BecomeACustomer_ConfirmationPage_URL} />
                <input hidden id="hdnregex" name="regex" value={bacSettingSettings.baC_SpecialCharacter_RegeEx} />
                <input
                    hidden
                    id={bacSettingSettings.naRedesign_BecomeACustomer_SF_LifecycleStatus}
                    name={bacSettingSettings.naRedesign_BecomeACustomer_SF_LifecycleStatus}
                    value={translate("Lifecycle Status Value")}
                />
                <Accordion headingLevel={4}>
                    <StyledWrapper {...styles.accordianContainer} ref={contactRef}
                        onClick={e => {
                            e.preventDefault();
                            setOpenContact(true);
                        }}>
                        <AccordionSection
                            title={translate("Contact Information")}
                            expanded={openContact}
                            {...styles.accordianSection}
                        >
                            <StyledWrapper {...styles.contentWrapper}>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_Company_ID}
                                        name={bacSettingSettings.baC_Company_ID}
                                        label={"Company "}
                                        {...styles.textFieldStyles}
                                        required
                                        value={companyName}
                                        onChange={e => companyNameHandler(e.target.value)}
                                        error={isSubmitted && companyError}
                                        
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_FirtName_ID}
                                        name={bacSettingSettings.baC_FirtName_ID}
                                        label={"First Name"}
                                        {...styles.textFieldStyles}
                                        required
                                        value={firstName}
                                        onChange={e => firstNameHandler(e.target.value)}
                                        error={isSubmitted && firstNameError}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_LastName_ID}
                                        name={bacSettingSettings.baC_LastName_ID}
                                        label={"Last Name"}
                                        {...styles.textFieldStyles}
                                        required
                                        value={lastName}
                                        onChange={e => lastNameHandler(e.target.value)}
                                        error={isSubmitted && lastNameError}
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_title_ID}
                                        name={bacSettingSettings.baC_title_ID}
                                        label={"Title"}
                                        {...styles.textFieldStyles}
                                        required
                                        value={title}
                                        onChange={e => titleHandler(e.target.value)}
                                        error={isSubmitted && titleError}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_TaxCertificate_ID}
                                        name={bacSettingSettings.baC_TaxCertificate_ID}
                                        label="Tax ID or License #"
                                        {...styles.textFieldStyles}
                                        required
                                        value={taxID}
                                        onChange={e => taxIDHandler(e.target.value)}
                                        error={isSubmitted && taxIDError}
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_WebSite_ID}
                                        name={bacSettingSettings.baC_WebSite_ID}
                                        label={"Company Website"}
                                        {...styles.textFieldStyles}
                                        value={companyWebiste}
                                        onChange={e => setCompanyWebiste(e.target.value)}
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_Phone_ID}
                                        name={bacSettingSettings.baC_Phone_ID}
                                        label={"Business Phone"}
                                        {...styles.textFieldStyles}
                                        required
                                        value={businessPhone}
                                        onChange={e => businessPhoneHandler(e.target.value)}
                                        error={isSubmitted && businessPhoneError}
                                        maxLength={10}
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_EXT_ID}
                                        name={bacSettingSettings.baC_EXT_ID}
                                        label={"Ext."}
                                        {...styles.textFieldStyles}
                                        value={extName}
                                        onChange={e => extHandler(e.target.value)}
                                        error={isSubmitted && extError}
                                        maxLength={5}
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_Mobile_ID}
                                        name={bacSettingSettings.baC_Mobile_ID}
                                        label={"Mobile Phone"}
                                        {...styles.textFieldStyles}
                                        value={mobilePhone}
                                        onChange={e => mobilePhoneHandler(e.target.value)}
                                        error={isSubmitted && mobilePhoneError}
                                        maxLength={10}
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_Email_ID}
                                        name={bacSettingSettings.baC_Email_ID}
                                        label={"Email Address"}
                                        {...styles.textFieldStyles}
                                        required
                                        value={email}
                                        onChange={e => emailChangeHandler(e.target.value)}
                                        error={isSubmitted && emailError}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id="ConfirmEmail"
                                        name="ConfirmEmail"
                                        label={"Confirm Email Address"}
                                        {...styles.textFieldStyles}
                                        required
                                        value={confirmEmail}
                                        onChange={e => confirmEmailChangeHandler(e.target.value)}
                                        error={isSubmitted && confirmEmailError}
                                    />
                                </StyledWrapper>
                                <StyledWrapper
                                    {...styles.checkboxWrapper}
                                    style={{
                                        marginTop: 36,
                                    }}
                                >
                                    <input
                                        id={bacSettingSettings.baC_Snap_ID}
                                        name={bacSettingSettings.baC_Snap_ID}
                                        type="checkbox"
                                        value="1"
                                        hidden
                                        checked={isChecked}
                                    />
                                    <Checkbox
                                        checked={isChecked}
                                        onChange={handleCheckboxChange}

                                    />

                                    <Typography {...styles.snapCustomer}>Are you a Snap One customer?</Typography>
                                </StyledWrapper>
                                {isChecked && (
                                    <StyledWrapper {...styles.fieldWrapper}
                                        style={{
                                            marginTop: 20,
                                        }}>

                                        <TextField
                                            id={bacSettingSettings.baC_SnapAccount_ID}
                                            name={bacSettingSettings.baC_SnapAccount_ID}
                                            value={inputValue}
                                            onChange={handleInputChange}
                                            maxLength={20}
                                            required
                                            label={"Snap One Account Number"}
                                            {...styles.textFieldStyles}
                                        />
                                    </StyledWrapper>
                                )}
                                
                                <StyledWrapper {...styles.nextButtonWrapper}>
                                    <Button type="button" onClick={contactNextHandler}>
                                        Next
                                    </Button>
                                </StyledWrapper>
                            </StyledWrapper>
                            <Typography {...styles.requiredStyles}>{translate("*Required fields.")}</Typography>
                        </AccordionSection>
                    </StyledWrapper>

                    <StyledWrapper {...styles.accordianContainer} ref={billingRef}
                        onClick={e => {
                            e.preventDefault();
                            setOpenBilling(true);
                        }}>
                        <AccordionSection
                            title={translate("Billing Address")}
                            expanded={openBilling}
                            {...styles.accordianSection}
                        >
                            <StyledWrapper {...styles.contentWrapper}>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_BillingAddressLine1_ID}
                                        name={bacSettingSettings.baC_BillingAddressLine1_ID}
                                        label={"Address Line 1"}
                                        {...styles.textFieldStyles}
                                        required
                                        value={billingAddress}
                                        onChange={e => billingAddressHandler(e.target.value)}
                                        error={isSubmitted && billingAddressError}
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_BillingAddressLine2_ID}
                                        name={bacSettingSettings.baC_BillingAddressLine2_ID}
                                        label={"Address Line 2"}
                                        {...styles.textFieldStyles}
                                        value={billingAddress2}
                                        onChange={e => handleBillingAddress2(e.target.value)}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_BillingCity_ID}
                                        name={bacSettingSettings.baC_BillingCity_ID}
                                        label={"City"}
                                        {...styles.textFieldStyles}
                                        required
                                        value={billingCity}
                                        onChange={e => billingCityHandler(e.target.value)}
                                        error={isSubmitted && billingCityError}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <Select
                                        id={bacSettingSettings.baC_BillingState_ID}
                                        name={bacSettingSettings.baC_BillingState_ID}
                                        label={"State "}
                                        required
                                        value={billingState}
                                        onChange={e => billingStateHandler(e.target.value)}
                                        error={isSubmitted && billingStateError}
                                    >
                                        <option value={""}>{translate("Select the State")}</option>
                                        {country?.states?.map(state => (
                                            <option value={state.abbreviation}>{state.name}</option>
                                        ))}
                                    </Select>
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_BillingPostalCode_ID}
                                        name={bacSettingSettings.baC_BillingPostalCode_ID}
                                        label={"Zip Code"}
                                        {...styles.textFieldStyles}
                                        required
                                        value={billingPostalCode}
                                        onChange={e => billingPostalCodeHandler(e.target.value)}
                                        error={isSubmitted && billingPostalCodeError}
                                        maxLength={5}
                                    />
                                </StyledWrapper>
                                <StyledWrapper
                                    {...styles.checkboxWrapper}
                                    style={{
                                        marginTop: 15,
                                    }}
                                >   <input
                                        id="chkBillingSameAsShiping"
                                        name="chkBillingSameAsShiping"
                                        type="checkbox"
                                        value="1"
                                        hidden
                                        checked={shippingSameAsBilling}
                                    />
                                    <Checkbox

                                        checked={shippingSameAsBilling}
                                        onChange={e => {
                                            setShippingSameAsBilling(!shippingSameAsBilling);
                                        }}
                                    />
                                    <Typography
                                        style={{
                                            marginLeft: 15,
                                        }}
                                    >
                                        {translate("Use Billing Address as Shipping Address")}
                                    </Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.nextButtonWrapper}>
                                    <Button type="button" onClick={billingNextHandler}>
                                        Next
                                    </Button>
                                </StyledWrapper>
                            </StyledWrapper>
                            <Typography {...styles.requiredStyles}>{translate("*Required fields.")}</Typography>
                        </AccordionSection>
                    </StyledWrapper>

                    <StyledWrapper {...styles.accordianContainer} ref={shippingRef}
                        onClick={e => {
                            e.preventDefault();
                            setOpenShipping(true);
                        }}>
                        <AccordionSection
                            title={translate("Shipping Address")}
                            expanded={openShipping}
                            {...styles.accordianSection}
                        >
                            <StyledWrapper {...styles.contentWrapper}>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_ShippingAddressLine1_ID}
                                        name={bacSettingSettings.baC_ShippingAddressLine1_ID}
                                        label={"Address Line 1"}
                                        {...styles.textFieldStyles}
                                        required
                                        className={`${shippingSameAsBilling ? "disabledField" : ""}`}
                                        value={shippingAddress}
                                        onChange={e => shippingAddressHandler(e.target.value)}
                                        error={isSubmitted && shippingAddressError}
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_ShippingAddressLine2_ID}
                                        name={bacSettingSettings.baC_ShippingAddressLine2_ID}
                                        label={"Address Line 2"}
                                        {...styles.textFieldStyles}
                                        className={`${shippingSameAsBilling ? "disabledField" : ""}`}
                                        value={shippingAddress2}
                                        onChange={e => setShippingAddress2(e.target.value)}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_ShippingCity_ID}
                                        name={bacSettingSettings.baC_ShippingCity_ID}
                                        label={"City"}
                                        {...styles.textFieldStyles}
                                        required
                                        className={`${shippingSameAsBilling ? "disabledField" : ""}`}
                                        value={shippingCity}
                                        onChange={e => shippingCityHandler(e.target.value)}
                                        error={isSubmitted && shippingCityError}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <Select
                                        id={bacSettingSettings.baC_ShippingState_ID}
                                        name={bacSettingSettings.baC_ShippingState_ID}
                                        label={"State "}
                                        required
                                        value={shippingState}
                                        onChange={e => shippingStateHandler(e.target.value)}
                                        error={isSubmitted && shippingStateError}
                                        {...(shippingSameAsBilling ? styles.selectStateStyes : styles.selectStateStylesDisabled)}

                                    >
                                        <option value={""}>{translate("Select the State")}</option>
                                        {country?.states?.map(state => (
                                            <option value={state.abbreviation}>{state.name}</option>
                                        ))}
                                    </Select>
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <TextField
                                        id={bacSettingSettings.baC_ShippingPostalCode_ID}
                                        name={bacSettingSettings.baC_ShippingPostalCode_ID}
                                        label={"Zip Code"}
                                        {...styles.textFieldStyles}
                                        required
                                        className={`${shippingSameAsBilling ? "disabledField" : ""}`}
                                        value={shippingPostalCode}
                                        onChange={e => shippingPostalCodeHandler(e.target.value)}
                                        error={isSubmitted && shippingPostalCodeError}
                                        maxLength={5}
                                    />
                                </StyledWrapper>

                                <StyledWrapper {...styles.nextButtonWrapper}>
                                    <Button type="button" onClick={shippingNextHandler}>
                                        Next
                                    </Button>
                                </StyledWrapper>
                            </StyledWrapper>
                            <Typography {...styles.requiredStyles}>{translate("*Required fields.")}</Typography>
                        </AccordionSection>
                    </StyledWrapper>

                    <StyledWrapper {...styles.accordianContainer} ref={companyRef}
                        onClick={e => {
                            e.preventDefault();
                            setOpenCompany(true);
                        }}>
                        <AccordionSection
                            title={translate("Company Information")}
                            expanded={opencompany}
                            {...styles.accordianSection}
                        >
                            <StyledWrapper {...styles.contentWrapper}>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <label> Please select the product line(s) you are interested in: *</label>
                                    {isSubmitted && !productLines.length && (
                                        <Typography data-test-selector="undefined-error">
                                            {translate("Select a product line.")}
                                        </Typography>
                                    )}
                                    {!isMobile ? (<StyledWrapper {...styles.checkboxGroupWrapper}>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_AccessControlCommunication_ID}
                                                name={bacSettingSettings.baC_AccessControlCommunication_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Access Control & Communications")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Access Control & Communications")}
                                                onChange={() =>
                                                    handleProductLineChange("Access Control & Communications")
                                                }
                                            />

                                            <Typography>Access Control & Communications</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_ProAV_ID}
                                                name={bacSettingSettings.baC_ProAV_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Pro AV")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Pro AV")}
                                                onChange={() => handleProductLineChange("Pro AV")}
                                            />

                                            <Typography>Pro AV</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_Power_ID}
                                                name={bacSettingSettings.baC_Power_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Power")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Power")}
                                                onChange={() => handleProductLineChange("Power")}
                                            />
                                            <Typography>{translate("Batteries & Power Supplies")}</Typography>
                                        
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_ResidentialAV_ID}
                                                name={bacSettingSettings.baC_ResidentialAV_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Residential AV")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Residential AV")}
                                                onChange={() => handleProductLineChange("Residential AV")}
                                            />

                                            <Typography>Residential AV</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_CentralVaccum_ID}
                                                name={bacSettingSettings.baC_CentralVaccum_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Central Vacuum")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Central Vacuum")}
                                                onChange={() => handleProductLineChange("Central Vacuum")}
                                            />

                                            <Typography>Central Vacuum</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>

                                            <input
                                                id={bacSettingSettings.baC_Solar_ID}
                                                name={bacSettingSettings.baC_Solar_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Solar")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Solar")}
                                                onChange={() => handleProductLineChange("Solar")}
                                            />

                                            <Typography>{translate("Solar")}</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_EnterpriseConnectivty_ID}
                                                name={bacSettingSettings.baC_EnterpriseConnectivty_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Enterprise Connectivity")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Enterprise Connectivity")}
                                                onChange={() => handleProductLineChange("Enterprise Connectivity")}
                                            />

                                            <Typography>{translate("Enterprise Connectivity")}</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_StructuredWiring_ID}
                                                name={bacSettingSettings.baC_StructuredWiring_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Structured Wiring")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Structured Wiring")}
                                                onChange={() => handleProductLineChange("Structured Wiring")}
                                            />

                                            <Typography>Structured Wiring</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_Fire_ID}
                                                name={bacSettingSettings.baC_Fire_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Fire")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Fire")}
                                                onChange={() => handleProductLineChange("Fire")}
                                            />

                                            <Typography>Fire</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_ToolsAndHardWare_ID}
                                                name={bacSettingSettings.baC_ToolsAndHardWare_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Tools & Hardware")}
                                            />

                                            <Checkbox
                                                checked={productLines.includes("Tools & Hardware")}
                                                onChange={() => handleProductLineChange("Tools & Hardware")}
                                            />

                                           <Typography>Tools & Hardware</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_IntrusionAndSmartHome_ID}
                                                name={bacSettingSettings.baC_IntrusionAndSmartHome_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Intrusion & Smart Home")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Intrusion & Smart Home")}
                                                onChange={() => handleProductLineChange("Intrusion & Smart Home")}
                                            />

                                            <Typography>Intrusion & Smart Home</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_VideoSurveillance_ID}
                                                name={bacSettingSettings.baC_VideoSurveillance_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Video Surveillance")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Video Surveillance")}
                                                onChange={() => handleProductLineChange("Video Surveillance")}
                                            />

                                            <Typography>Video Surveillance</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                            <input
                                                id={bacSettingSettings.baC_Networking_ID}
                                                name={bacSettingSettings.baC_Networking_ID}
                                                type="checkbox"
                                                value="1"
                                                hidden
                                                checked={productLines.includes("Networking")}
                                            />
                                            <Checkbox
                                                checked={productLines.includes("Networking")}
                                                onChange={() => handleProductLineChange("Networking")}
                                            />

                                            <Typography>Networking</Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_WireandCable_ID}
                                                    name={bacSettingSettings.baC_WireandCable_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Wire & Cable")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Wire & Cable")}
                                                    onChange={() => handleProductLineChange("Wire & Cable")}
                                                />

                                                <Typography>Wire & Cable</Typography>
                                            </StyledWrapper>
                                    </StyledWrapper>) :
                                        (<StyledWrapper {...styles.checkboxGroupWrapper}>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_AccessControlCommunication_ID}
                                                    name={bacSettingSettings.baC_AccessControlCommunication_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Access Control & Communications")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Access Control & Communications")}
                                                    onChange={() =>
                                                        handleProductLineChange("Access Control & Communications")
                                                    }
                                                />

                                                <Typography>Access Control & Communications</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_Power_ID}
                                                    name={bacSettingSettings.baC_Power_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Power")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Power")}
                                                    onChange={() => handleProductLineChange("Power")}
                                                />

                                                <Typography>Batteries & Power Supplies</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_CentralVaccum_ID}
                                                    name={bacSettingSettings.baC_CentralVaccum_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Central Vacuum")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Central Vacuum")}
                                                    onChange={() => handleProductLineChange("Central Vacuum")}
                                                />

                                                <Typography>Central Vacuum</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_EnterpriseConnectivty_ID}
                                                    name={bacSettingSettings.baC_EnterpriseConnectivty_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Enterprise Connectivity")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Enterprise Connectivity")}
                                                    onChange={() => handleProductLineChange("Enterprise Connectivity")}
                                                />

                                                <Typography>{translate("Enterprise Connectivity")}</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_Fire_ID}
                                                    name={bacSettingSettings.baC_Fire_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Fire")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Fire")}
                                                    onChange={() => handleProductLineChange("Fire")}
                                                />

                                                <Typography>Fire</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_IntrusionAndSmartHome_ID}
                                                    name={bacSettingSettings.baC_IntrusionAndSmartHome_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Intrusion & Smart Home")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Intrusion & Smart Home")}
                                                    onChange={() => handleProductLineChange("Intrusion & Smart Home")}
                                                />

                                                <Typography>Intrusion & Smart Home</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_Networking_ID}
                                                    name={bacSettingSettings.baC_Networking_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Networking")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Networking")}
                                                    onChange={() => handleProductLineChange("Networking")}
                                                />

                                                <Typography>Networking</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_ProAV_ID}
                                                    name={bacSettingSettings.baC_ProAV_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Pro AV")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Pro AV")}
                                                    onChange={() => handleProductLineChange("Pro AV")}
                                                />

                                                <Typography>Pro AV</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_ResidentialAV_ID}
                                                    name={bacSettingSettings.baC_ResidentialAV_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Residential AV")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Residential AV")}
                                                    onChange={() => handleProductLineChange("Residential AV")}
                                                />

                                                <Typography>Residential AV</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>

                                                <input
                                                    id={bacSettingSettings.baC_Solar_ID}
                                                    name={bacSettingSettings.baC_Solar_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Solar")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Solar")}
                                                    onChange={() => handleProductLineChange("Solar")}
                                                />

                                                <Typography>Solar</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_StructuredWiring_ID}
                                                    name={bacSettingSettings.baC_StructuredWiring_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Structured Wiring")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Structured Wiring")}
                                                    onChange={() => handleProductLineChange("Structured Wiring")}
                                                />

                                                <Typography>Structured Wiring</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_ToolsAndHardWare_ID}
                                                    name={bacSettingSettings.baC_ToolsAndHardWare_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Tools & Hardware")}
                                                />

                                                <Checkbox
                                                    checked={productLines.includes("Tools & Hardware")}
                                                    onChange={() => handleProductLineChange("Tools & Hardware")}
                                                />

                                                <Typography>Tools & Hardware</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_VideoSurveillance_ID}
                                                    name={bacSettingSettings.baC_VideoSurveillance_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Video Surveillance")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Video Surveillance")}
                                                    onChange={() => handleProductLineChange("Video Surveillance")}
                                                />

                                                <Typography>Video Surveillance</Typography>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.checkboxWrapper}>
                                                <input
                                                    id={bacSettingSettings.baC_WireandCable_ID}
                                                    name={bacSettingSettings.baC_WireandCable_ID}
                                                    type="checkbox"
                                                    value="1"
                                                    hidden
                                                    checked={productLines.includes("Wire & Cable")}
                                                />
                                                <Checkbox
                                                    checked={productLines.includes("Wire & Cable")}
                                                    onChange={() => handleProductLineChange("Wire & Cable")}
                                                />

                                                <Typography>Wire & Cable</Typography>
                                            </StyledWrapper>
                                        </StyledWrapper>)}
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <label>How many years has your company been in business? *</label>
                                    <Select
                                        id={bacSettingSettings.baC_CompanyYears_ID}
                                        name={bacSettingSettings.baC_CompanyYears_ID}
                                        required
                                        value={yearsInBusiness}
                                        onChange={e => yearsInBusinessHandler(e.target.value)}
                                        error={isSubmitted && yearsInBusinessError}
                                    >
                                        <option value={""}>Select</option>
                                        <option value={"Less than 1"}>Less than 1</option>
                                        <option value={"1-5"}>1-5</option>
                                        <option value={"6-10"}>6-10</option>
                                        <option value={"11-15"}>11-15</option>
                                        <option value={"16-20"}>16-20</option>
                                        <option value={"21-25"}>21-25</option>
                                        <option value={"More than 25"}>More than 25</option>
                                    </Select>
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <label>How many employees does your company employ? *</label>
                                    <Select
                                        id={bacSettingSettings.baC_EmployeeCount_ID}
                                        name={bacSettingSettings.baC_EmployeeCount_ID}
                                        required
                                        value={employeeCompany}
                                        onChange={e => companyEmployeeHandler(e.target.value)}
                                        error={isSubmitted && employeeCompanyError}
                                    >
                                        <option value={""}>Select</option>
                                        <option value={"1"}>1</option>
                                        <option value={"2-10"}>2-10</option>
                                        <option value={"11-25"}>11-25</option>
                                        <option value={"More than 25"}>More than 25</option>
                                    </Select>
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <label>How many locations does your company have? *</label>
                                    <Select
                                        id={bacSettingSettings.baC_CompanyLocation_ID}
                                        name={bacSettingSettings.baC_CompanyLocation_ID}
                                        required
                                        value={companyLocations}
                                        onChange={e => companyLocationsHandler(e.target.value)}
                                        error={isSubmitted && companyLocationsError}
                                    >
                                        <option value={""}>Select</option>
                                        <option value={"1"}>1</option>
                                        <option value={"2-5"}>2-5</option>
                                        <option value={"6-25"}>6-25</option>
                                        <option value={"More than 25"}>More than 25</option>
                                    </Select>
                                </StyledWrapper>
                                <StyledWrapper {...styles.fieldWrapper}>
                                    <label>Comments</label>
                                    <textarea
                                        id={bacSettingSettings.baC_Comment_ID}
                                        name={bacSettingSettings.baC_Comment_ID}
                                        onChange={e => setComments(e.target.value)}
                                        value={comments}
                                    ></textarea>
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <StyledWrapper {...(isSubmitted && !lisenceInstallerCheck) ? styles.checkboxWrapperError : styles.checkboxWrapper}>
                                        <input
                                            id="LicensedInstaller"
                                            name="LicensedInstaller"
                                            type="checkbox"
                                            hidden
                                            checked={lisenceInstallerCheck}
                                        />
                                        <Checkbox
                                            checked={lisenceInstallerCheck}
                                            onChange={() => setlisenceInstallerCheck(!lisenceInstallerCheck)}
                                        />
                                        <Typography
                                            style={{
                                                marginLeft: 15,
                                            }}
                                        >
                                            I confirm that I am a licensed installer and I understand that ADI does not
                                            sell direct to end users.
                                        </Typography>
                                    </StyledWrapper>
                                    {isSubmitted && !lisenceInstallerCheck && (
                                        <Typography data-test-selector="undefined-error">
                                            {translate(" Check to confirm you are a licensed installer ")}
                                        </Typography>
                                    )}
                                </StyledWrapper>

                                <StyledWrapper {...styles.fieldWrapper}>
                                    <StyledWrapper {...(isSubmitted && !agreeTerms) ? styles.checkboxWrapperError : styles.checkboxWrapper}>
                                        <input
                                            id="TermConditions"
                                            name="TermConditions"
                                            type="checkbox"
                                            hidden
                                            checked={agreeTerms}
                                        />
                                        <Checkbox checked={agreeTerms} onChange={() => setAgreeTerms(!agreeTerms)} />
                                        <Typography
                                            style={{
                                                marginLeft: 15,
                                            }}
                                        >
                                            I have read and agree to the{" "}
                                            

                                            <Link>
                                              <a onClick={linkclick} target="_blank" rel="noopener noreferrer" >terms and conditions</a>  
                                            </Link>

                                        </Typography>
                                    </StyledWrapper>
                                    {isSubmitted && !agreeTerms && (
                                        <Typography data-test-selector="undefined-error">
                                            {translate("Read and agree to the terms & conditions to continue.")}
                                        </Typography>
                                    )}
                                </StyledWrapper>
                                <StyledWrapper {...styles.captchaFieldWrapper}>
                                    <ReCaptcha recaptchaRef={recaptchaRef} location="CreateAccount" userCaptchaValid={userCaptchaValid} />
                                {
                                        isSubmitted && !captchaSelectError && (
                                            <Typography data-test-selector="undefined-error">
                                                {
                                                    translate("Check the Captcha box to continue.")
                                                }
                                            </Typography>
                                        )
                                    }


                       </StyledWrapper>
                                <StyledWrapper {...styles.nextButtonWrapper}>
                                    <Button type="submit" onClick={(e) => e.stopPropagation()}>Submit</Button>

                                </StyledWrapper>
                            </StyledWrapper>
                            <StyledWrapper>
                                {/* not displaying in Ui but passing in API paylod */}
                                <StyledWrapper className="rightsection" {...styles.bacCountrySectionHide} >
                                    <StyledWrapper className="columns">
                                        <select
                                            id={bacSettingSettings.baC_BillingCountry_ID}
                                            name={bacSettingSettings.baC_BillingCountry_ID}
                                            ng-model="vm.billToSelectedCountry"
                                            data-rule-required="true"
                                            data-msg-required="[% translate ' Country is a required field.' %]"
                                            ng-change="vm.onblur('country')">
                                            <option value="">{translate("Select the Country")}</option>
                                            <option value={country?.abbreviation} selected>{country?.name}</option>
                                        </select>
                                        <StyledWrapper data-valmsg-replace="true" data-valmsg-for="{{vm.bacSettings.baC_BillingCountry_ID}}"></StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                            <Typography {...styles.requiredStyles}>{translate("*Required fields.")}</Typography>
                        </AccordionSection>
                    </StyledWrapper>
                </Accordion>
            </StyledForm>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ADICustomerRegistration)),
    definition: {
        group: "Basic",
        displayName: "ADI Customer Registration",
    },
};

export default widgetModule;
